import {EventEmitter, Injectable} from '@angular/core';
import {BehaviorSubject, interval, Observable, of, Subject, timer} from "rxjs";
import {itemFactory} from '../../classes/itemFactory'
import {ServerConnectionService} from "../serverConnection/server-connection.service";
import {appInjector} from "../../classes/appInjector";
import {ToolsService} from "../toolsService/tools.service";
import {ItemConfig} from "../../models/ItemConfig";
import {Item} from "../../models/Item";
import {MapPosition} from "../../models/MapPosition";
import {UiAdapterService} from "../uiAdapterService/ui-adapter.service";
import {CookieService} from "../coockieService/coockie.service";
import {EsBsModalService} from "../bsModalService/bs-modal.service";
import {Group} from "../../classes/Groups/Group";
import {GroupService} from "../groupService/group-service.service";
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {debounceTime, takeUntil, takeWhile} from "rxjs/operators";
import {ObjectArrayService} from "../../classes/plugins/objectArrayPlugin/object-array-service/ObjectArrayService";

@Injectable({
  providedIn: 'root'
})
export class ItemManagerService{
  isFastLineSignUp: boolean;
  private _itemsList: BehaviorSubject<Item[]> = new BehaviorSubject<Item[]>([]);
  get itemsList():Observable<any>{
    return this._itemsList.asObservable();
  }
  public itemAdded: Subject<any> = new Subject<object>();
  get itemAdded$(){
    return this.itemAdded.asObservable();
  }
  public groupVisibilities: Object = {};
  public componentEnvironmentCb;
  duplicateCallCounts: { [itemId: string]: number } = {};
  private selectedItemsGroup = {};
  private _selectedItemList$:Subject<Object> = new Subject<Object>();
  private groupCreatingPending = new Map<string, any>();

  get selectedItemList(){
    return this.selectedItemsGroup;
  }

  get selectedItemList$(){
    return this._selectedItemList$.asObservable();
  }
  private selectedSubscribers = {};
  private oldPosition = {};
  private checkForRequestItems = new Map<number|string, Item>();
  public isDragTriggered = false;
  private _isDragTriggeredChanged = new Subject();
  set isDragTriggeredChanged(val){
    this._isDragTriggeredChanged.next(val);
  }
  get isDragTriggeredChanged():any{
    return this._isDragTriggeredChanged.asObservable();
  }

  protected listeners: Map<string, Function[]> = new Map<string, Function[]>();

  static readonly BEFORE_ITEM_ADD = 'beforeItemAdd';


  constructor(
    private itemFactory: itemFactory,
    private uiAdapterService: UiAdapterService,
    private serverConnection: ServerConnectionService,
    private cookieService: CookieService,
    protected modalControl: EsBsModalService,
    private groupService: GroupService,
    private objectArr: ObjectArrayService
  ) {
    window['removeAllItems'] = ()=>{
      this._itemsList.getValue().forEach((i)=>{
        i.removeObject();
      })
    }
  }

  protected dispatch(event: string, params: any, _cb?) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(cb => {
        cb(params, _cb);
      });
    }
  }

  public on(event: string, cb: Function) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    let l = this.listeners.get(event);
    l.push(cb);
    this.listeners.set(event, l);
  }

  private registerItem(item: Item, cb?) {
    let itemList = this._itemsList.getValue();

    // An offline default (for fast line signup)
    // let groupPromise: Promise<Group> = new Promise(resolve => resolve(new Group({id: -1})));

    this.bindItemToGroup(item, itemList, cb);


    // if (!this.isFastLineSignUp) {
    //   console.log('!this.isFastLineSignUp', this.isFastLineSignUp);
    //   groupPromise = this.getItemGroup(item);
    // }

    // console.log('registerItem', groupPromise)

    // groupPromise.then((_itemGroup:Group)=>{
    //   // console.log('groupPromise', _itemGroup);
    //   if (!_itemGroup){
    //     return;
    //   }
    //   _itemGroup.addItem(item);
    //   itemList[item.getId()] = item;
    //
    //   this._itemsList.next(itemList);
    //   this.itemAdded.next(item);
    //
    //   item.onAddedToItemManager();
    //   this.initListeners(item);
    // });
  }

  public updateSelectedItemsGroup(){
    this._selectedItemList$.next(this.selectedItemsGroup);
  }

  public processItemGroup(item, _itemGroup, itemList, cb?) {
    if (!_itemGroup){
      if (cb){ cb()}
      return;
    }
    _itemGroup.addItem(item);
    itemList[item.getId()] = item;

    this._itemsList.next(itemList);
    this.itemAdded.next(item);

    item.onAddedToItemManager();
    this.initListeners(item);
    if (cb){ cb()}
  }

  public setNewItemGroupByConfig(item:Item){
    let oldGroup = this.groupService.getGroupById(item.config.getGroupId());
    oldGroup.removeItem(item);
    item.config.setGroupId(null);
    let groupPromise = this.getItemGroup(item);
    groupPromise.then((_itemGroup:Group)=>{
      _itemGroup.addItem(item);
      this._itemsList.next(this._itemsList.getValue());
    })
  }

  private getItemGroup(item): Promise<Group> {
    return new Promise((resolve)=>{
      let itemGroup = item.config.getGroupId();
      //if item hasn't group
      if (typeof itemGroup == "string"){
        let tool = item.config.getTool();
        if (tool){
          this.processNewGroupByTool(tool, itemGroup, item, resolve);
        }
        else{
          //if item hasn't tool
          let emptyGroup = this.groupService.getGroupById(null);
          if (!emptyGroup){
            this.groupService.initEmptyGroup((group)=>{
              resolve(group)
            })
          }
          return resolve(emptyGroup);
        }
      }
      //if item has group id
      else{
        return resolve(this.groupService.getGroupById(itemGroup));
      }
    });
  }

  private processNewGroupByTool(tool, itemGroup, item, resolve){
    // let currentSelectedElement:ConcreteHierarchyItemInterface = (this.uiAdapterService.currentSelectedItem && typeof this.uiAdapterService.currentSelectedItem == 'object' && this.uiAdapterService.currentSelectedItem.currentObject) ? this.uiAdapterService.currentSelectedItem.currentObject.item : this.uiAdapterService.currentSelectedItem;

    let floorPlanId = null;
    if(item instanceof ConcreteLayer){
      floorPlanId = (!item) ? null : item.id;
    }
    else{
      floorPlanId = (!item) ? null : item.getParentConcreteId();
    }

    let group = this.groupService.getGroupByCategoryName(tool.category, floorPlanId);

    if (group){
      return resolve(group)
    }
    else{
      // note: [SHR]: difference
      // //tool.category.id
      // this.groupService.createGroup({title: itemGroup, from_object_category_id: null,   floorplan_id: floorPlanId}, (_group)=>{
      //   resolve(_group);
      // }, true);
      // console.log('itemGroup', itemGroup);
      // console.log('this.groupCreatingPending', this.groupCreatingPending);
      if (this.groupCreatingPending.has(itemGroup)){
        // console.log('this.groupCreatingPending.has(itemGroup) 123321', this.groupCreatingPending.has(itemGroup));
        timer(500).subscribe(()=>{
          this.processNewGroupByTool(tool, itemGroup, item, resolve);
        });
        return;
      }

      // console.log('this.groupCreatingPending.set', itemGroup);
      this.groupCreatingPending.set(itemGroup, floorPlanId);
      // console.log('createGroup 123321', itemGroup)
      if (this.isFastLineSignUp){
        this.groupService.createGroupForFastLine({title: itemGroup, from_object_category_id: tool.category.id, floorplan_id: floorPlanId}, (_group)=>{
          this.groupCreatingPending.delete(itemGroup);
          resolve(_group);
        });
        return;
      }
      this.groupService.createGroup({title: itemGroup, from_object_category_id: tool.category.id, floorplan_id: floorPlanId}, (_group)=>{
        this.groupCreatingPending.delete(itemGroup);
        // console.log('this.groupCreatingPending', this.groupCreatingPending);
        // console.log('this.groupCreatingPending delete (itemGroup) 123321', this.groupCreatingPending.has(itemGroup));
        resolve(_group);
      }, true);
    }
  }

  // private registerDrawnItem(item){
  //   let itemList = this._itemsList.getValue();
  //   itemList[item.getId()] = item;
  //
  //   // item.drag_enabled = true;
  //   // item.timer = setTimeout(()=>{
  //   //   item.drag_enabled = false;
  //   //   item.timer = null;
  //   // }, 10000)
  //
  //   this._itemsList.next(itemList);
  //   this.itemAdded.next(item);
  //
  //
  //   this.initListeners(item);
  // }

  addItem(itemConfig : ItemConfig){
    let toolProvider = appInjector.get(ToolsService);
    if (!toolProvider.canUseToolById(itemConfig.getTool())) {
      console.error("Object '" + itemConfig.getTitle() + "' (#" + itemConfig.getId() + ") is not in allowed categories");
      return;
    }
    if (itemConfig.isFixedFigure()) {
      let position = itemConfig.getObjectConfig().getPosition();
      if (!position || !position.lat || !position.lng) {
        let center = itemConfig.getObjectConfig().getCenter();
        let latLngs = itemConfig.getObjectConfig().getRawPositions();
        if (center && center.lat && center.lng) {
          itemConfig.getObjectConfig().setData('position', center.asSimpleObject(), true);
        } else if (latLngs && latLngs.hasOwnProperty('lat') && latLngs['lat'] && latLngs.hasOwnProperty('lng') && latLngs['lng']) {
          itemConfig.getObjectConfig().setData('position', latLngs, true);
        } else {
          console.error("Object '" + itemConfig.getTitle() + "' (#" + itemConfig.getId() + ") has bad position");
          return;
        }
      }
    } else if (itemConfig.isPolygon()) {
      let positions = itemConfig.getObjectConfig().getPositions();
      if (!positions || positions.length < 3) {
        console.error("Object '" + itemConfig.getTitle() + "' (#" + itemConfig.getId() + ") has bad position");
        return;
      }
    }

    let item = this.itemFactory.createFromSimpleItem(itemConfig);

    if (item) {
      this.registerItem(item);
    }
    return item;
  }

  addDrawnItem(object){
    let self = this;
    return new Promise((resolve, reject)=>{
      let item = self.itemFactory.createDrawnObject(object);

      self.dispatch(ItemManagerService.BEFORE_ITEM_ADD, item, ()=>{
        item.save()
          .then(()=>{
            this.registerItem(item);
            // item.getSubject(Item.DRAWN_ITEM_ADDED).next(object.id)
            item.getSubject(Item.UNDO_SUBJECT).next(item.config);
            resolve(item);
            this.uiAdapterService.selectedItem$ = item;
            // item.centerOnObj();
          }).catch((error)=>{})
      });
    })
  }

  addItemByConfig(config:ItemConfig, isAddedByGroup?, oldConfigId?){
    let item = this.itemFactory.createFromSimpleItem(config);
    item.save()
      .then((result)=>{
        this.registerItem(item);
        if (!isAddedByGroup){
         return item.getObservable('addedByConfig').next(item.getId());
        }

        if (item.config.isCopy){
          return interval(1000).pipe(takeWhile((config)=>{return !this.objectArr.undoItemsList[item.config.isCopy]}, true)).subscribe(()=>{
            item.getSubject('UPDATE_COPY_ID').next(true)
          })
        }
        this.objectArr.undoItemsList[oldConfigId] = item.getId();
        // item.centerOnObj();
      }).catch((error)=>{})
  }

  addItemByOutsideConfig(config:{tool, position}){
    return new Observable((observer)=>{
    let item = this.itemFactory.createDrawnObject(config);
    item.save()
      .then(()=>{
        this.registerItem(item);
        this.uiAdapterService.selectedItem$ = item;
        observer.next(item)
      }).catch((error)=>{})
    })
  }

  duplicateItemAsCopy(baseItem: Item, position, additionalSceneRotation?, direction?, positionInCopies?) {
    return new Promise((_resolve) => {
      let baseConfig = baseItem.config.asSimpleObject(); // make a copy of config object
      baseConfig.copyDirection = (direction) ? direction : baseItem.config.copyDirection;
      if (positionInCopies){
        baseConfig['inputs']['__positionInCopies'] = {'value': JSON.stringify(positionInCopies)};
      }
      if (baseConfig['inputs']['__objectArray'] && baseConfig['inputs']['__objectArray']['value']){
        delete baseConfig['inputs']['__objectArray'];
      }

      baseConfig['copyOf'] = baseConfig['id'];
      baseConfig['objects'][0]['position'] = position;
      if (additionalSceneRotation != 0) {
        baseConfig['objects'][0]['rotation'] -= additionalSceneRotation;
      }
      baseConfig['id'] = null; // unlink from existing object
      let item = this.itemFactory.createFromSimpleItem(baseConfig);
      item.save().then(() => {
        this.registerItem(item, ()=>{
          _resolve(item);
        });
      });
    });
  }

  // note: [SHR]: difference
  // duplicateItem(baseItem:Item, isWithoutOffset?) {
  //   return new Promise((resolve, reject) => {
  //     let baseConfig = baseItem.config.asSimpleObject(); // make a copy of config object
  //     baseConfig['id'] = null; // unlink from existing object
  //     let item = this.itemFactory.createFromSimpleItem(baseConfig);
  //     item.save().then(() => {
  //       this.registerItem(item);
  //       if (!isWithoutOffset) {
  //         item.getSubject(Item.UNDO_SUBJECT).next(item.config);
  //         item.getSubject(Item.OBJECT_OFFSET_BY).next({latitude: 0, longitude: .0001});
  //       }
  //       console.log('new item', item);
  //       resolve(item);
  //       return;
  //     })
  //   })
  // }

  // For line breaks
  justDuplicateItemById(id, objectConfigUpdate) {
    return new Promise((resolve) => {
      let baseItem = this.getItemById(id);
      if (!baseItem) {
        resolve(null);
      }
      const baseConfig = baseItem.config.asSimpleObject(); // make a copy of config object
      if (objectConfigUpdate) {
        baseConfig.objects[0] = Object.assign(baseConfig.objects[0], objectConfigUpdate);
      }
      baseConfig['id'] = null; // unlink from existing object
      const item = this.itemFactory.createFromSimpleItem(baseConfig);
      item.save().then(() => {
        this.registerItem(item);
        //item.getSubject(Item.UNDO_SUBJECT).next(item.config);
        resolve(item);
        return;
      });
    });
  }

    duplicateItem(baseItem: Item, isWithoutOffset?, overrideOptions?, duplicateCallCounts?: Number, actionId?) {
      return new Promise((resolve, reject) => {
          let baseConfig = baseItem.config.asSimpleObject(); // make a copy of config object
          baseConfig['id'] = null; // unlink from existing object
          let circle = baseItem.config.isCircle()

          if (overrideOptions){
              for (let i in overrideOptions){
                  baseConfig[i] = overrideOptions[i];
              }
          }

          let item = this.itemFactory.createFromSimpleItem(baseConfig);
          item.save().then(()=>{
              this.registerItem(item);
              if (!isWithoutOffset) {

                item.getSubject(Item.UNDO_SUBJECT).next(Object.assign({}, item.config, {actionId}));
                let counts = duplicateCallCounts ? Number(duplicateCallCounts) : 1;
                let longitudeOffset = 0.0001;

                if (circle) {
                  let center = item.config.getObjectConfig().getCenter();
                  let radiusInDegrees = this.metersToLongitudeDegrees(
                    item.config.getObjectConfig().getRadius(),
                    center.latitude
                  );
                  longitudeOffset = counts * (radiusInDegrees + longitudeOffset);
                } else {
                  longitudeOffset *= counts;
                }

                item.getSubject(Item.OBJECT_OFFSET_BY).next({ latitude: 0, longitude: longitudeOffset });
              }

          item.drag_enabled = true;
          item.timer = setTimeout(() => {
            item.drag_enabled = false;
            item.timer = null;
            if (!this.cookieService.checkCookie('isDraggableModalShow')) {
              this.modalControl.currentModal = '.items-lock-modal';
              this.modalControl.openModal({backdrop: true, keyboard: false});
            }
            this.isDragTriggered = true;
            this.isDragTriggeredChanged = true;
          }, 10000);

          this.uiAdapterService.selectedItem$ = item;
          resolve(item);
          return;
        });
      });
    }

    private metersToLongitudeDegrees(meters, latitude) {
      const earthRadius = 6378137;
      const radLat = latitude * Math.PI / 180;
      const metersPerDegree = (Math.PI / 180) * earthRadius * Math.cos(radLat);
      return meters / metersPerDegree;
    }

  getItemById(id):Item{
    return this._itemsList.getValue()[id];
  }

  getItemsByToolId(toolId):Item[]{
   let result:Item[] = [];
   let itemsObjectTMP = Object.assign({}, this._itemsList.getValue());
   for (let key in itemsObjectTMP){
     let item:Item = itemsObjectTMP[key];
     if (item.config.getToolId() == toolId){
       result.push(item);
     }
   }
   return result;
  }

  getItemsWithFloorplanId(floorplanId){
    let items = this.getAllItems();
    return items.filter((i:Item)=>{
      return i.config.getConcreteLayerId() == floorplanId && i.isVisible();
    })
  }

  getAllItems(): Item[] {
    let result:Item[] = [];
    let itemsObjectTMP = Object.assign({}, this._itemsList.getValue());
    for (let key in itemsObjectTMP){
      let item:Item = itemsObjectTMP[key];
      result.push(item);
    }
    return result;
  }

  getAllItemCopies(item:Item):Item[]{
    let result:Item[] = [];
    let itemsObjectTMP = Object.assign({}, this._itemsList.getValue());
    for (let key in itemsObjectTMP){
      let _item:Item = itemsObjectTMP[key];
      if (_item.config.getCopyParentId == item.getId()){
        result.push(_item);
      }
    }
    return result;
  }

  getAllSimpleItems(): Partial<Item>[] {
    return this._itemsList
      .getValue()
      .map((item: Item) => item.config.asSimpleObject());
  }

  public removeItem(item:Item, dontRemoveFromServer?){
    let id = item.getId();
    if(dontRemoveFromServer){
      let list = this._itemsList.getValue();
      delete list[id];
      this._itemsList.next(list);
    }
    else{
      this.serverConnection.removeObject(id).subscribe((result)=>{
          if(result){
            let list = this._itemsList.getValue();
            delete list[id];
            this._itemsList.next(list);
          }
        },
        (error)=>{
          console.error('error', error);
        })
    }

    if (this.selectedItemsGroup.hasOwnProperty(id)){
      delete this.selectedItemsGroup[id];
      this._selectedItemList$.next(this.selectedItemsGroup);
    }
  }

  toggleItemVisibility(item){
    (item.is_visible) ? item.onHideItem() : item.onShowItem();
    item.is_visible = !item.is_visible;
  }

  getEnvironmentConfig() {
    return { groups: JSON.parse(JSON.stringify(this.groupVisibilities)) };
  }

  setEnvironmentConfig(config, active = true) {
    if (this.componentEnvironmentCb) {
      this.componentEnvironmentCb(config);
    }
  }

  registerEnvironmentCb(cb) {
    this.componentEnvironmentCb = cb;
  }

  setGroupVisibility(name, key, value) {
    if (!this.groupVisibilities.hasOwnProperty(name)) {
      this.groupVisibilities[name] = {};
    }
    this.groupVisibilities[name][key] = value;
  }

  getVisibleItems(rect) {
    let items:Item[] = <Item[]>this._itemsList.getValue();
    let result = [];
    for (const [id, item] of Object.entries(items)) {
      if (item.isVisible() && item.isDrawn) {
        let positions = [];
        if (item.config.isFixedFigure()) {
          positions.push(item.config.getObjectConfig().getPosition());
        } else {
          positions = item.config.getObjectConfig().getPositions();
        }
        let insideRect = false;
        console.log(positions, rect);
        for (let i = 0; i < positions.length; i++) {
          if (
            positions[i].lat > rect.south && positions[i].lat < rect.north
            && positions[i].lng > rect.west && positions[i].lng < rect.east
          ) {
            insideRect = true;
            break;
          }
        }
        if (insideRect) {
          result.push(item);
        }
      }
    }
    return result;
  }

  getVisibleItemLegend(rect) {
    let items = this.getVisibleItems(rect);
    let result = [];
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      result.push({title:item.config.getTitle(), toolId: item.config.getToolId()});
    }
    return result;
  }

  getItemLegend() {
    let items:Item[] = <Item[]>this._itemsList.getValue();
    let result = [];
    for (const [id, item] of Object.entries(items)) {
      result.push({title:item.config.getTitle(), toolId: item.config.getToolId()});
    }
    return result;
  }

  private getChangedPosition(item, newConfig){
    return (item.getSubjectValue('linked_objects_anchor') ? item.getSubjectValue('linked_objects_anchor') : null);
    // if (Array.isArray(this.oldPosition[item.getId()])){
    //   if ( JSON.stringify(newConfig.getPositions()) != JSON.stringify(this.oldPosition[item.getId()])){
    //     return newConfig.getPositions();
    //   }
    // }
    // else{
    //   if (JSON.stringify(newConfig.getPosition()) != JSON.stringify(this.oldPosition[item.getId()])){
    //     return newConfig.getPosition();
    //   }
    // }
    // return null
  }

  private getCalculatedOffset(oldPos, newPos):MapPosition{
    // if (Array.isArray(oldPos)){
    //   return new MapPosition({lat: newPos[0].latitude - oldPos[0].latitude, lng: newPos[0].longitude - oldPos[0].longitude, z: newPos[0].height})
    // }
      return new MapPosition({lat: newPos.lat - oldPos.lat, lng: newPos.lng - oldPos.lng})
  }

  private subscribeToConfig(item:Item){
    this.selectedSubscribers[item.getId()] = item.config.getObjectConfig().subject.subscribe((newConfig)=>{

      let changedPosition = this.getChangedPosition(item, newConfig);
      if (!changedPosition) { return; }
      let oldPosition = this.oldPosition[item.getId()];
      this.oldPosition[item.getId()] = changedPosition;

      if (this.checkForRequestItems.has(item.getId().toString())){
        this.checkForRequestItems.delete(item.getId());
        return;
      }


      let offset = null;
      if (changedPosition && oldPosition){
        offset = this.getCalculatedOffset(oldPosition, changedPosition)
      }

      if (offset){
        for (let i in this.selectedItemsGroup){
          let _item = this.selectedItemsGroup[i];
          if (i == item.getId()){
            _item.getSubject(Item.OBJECT_OFFSET_BY).next(0)
          }
          else{
            this.checkForRequestItems.set(i, _item);
            _item.getSubject(Item.OBJECT_OFFSET_BY).next(offset);
          }
        }
      }
    })
  }

  checkAndClearSelectedItems(item: Item): void {
    if (this.selectedItemsGroup.hasOwnProperty(item.getId())) {
      return this.removeFromSelectedGroup(item);
    }
  }


  isInSelectedItems(item:Item): boolean {
    return this.selectedItemsGroup.hasOwnProperty(item.getId()) && Object.keys(this.selectedItemsGroup).length > 1;
  }


  toggleSelectedItem(item:Item){
    if (this.selectedItemsGroup.hasOwnProperty(item.getId())){
      return this.removeFromSelectedGroup(item);
    }
    this.addToSelectedGroup(item);
  }
  public addToSelectedGroup(item:Item){
    this.selectedItemsGroup[item.getId()] = item;
    item.getObservable('highlight_object').next(true);
    // let pos:Object = item.getSubjectValue('linked_objects_anchor');
    // if (!pos) { return; }
    // if (pos instanceof MapPosition) {
    //   pos = pos.asSimpleObject();
    // }
    // pos = (Array.isArray(pos)) ? pos.slice(0) : Object.assign({}, pos);

    // this.oldPosition[item.getId()] = pos;
    // this.subscribeToConfig(item);
    this._selectedItemList$.next(this.selectedItemsGroup);
  }

  clearSelectedGroup(){
      for (let i in this.selectedItemsGroup){
        this.removeFromSelectedGroup(this.selectedItemsGroup[i]);
      }
  }

  private removeFromSelectedGroup(item:Item){
    // this.selectedSubscribers[item.getId()].unsubscribe();
    delete this.selectedItemsGroup[item.getId()];
    item.getObservable('highlight_object').next(false);
    delete this.oldPosition[item.getId()];
    this._selectedItemList$.next(this.selectedItemsGroup)
  }

  private initListeners(item: Item) {
    item.getSubject(Item.OBJECT_CLICK)
      .pipe(debounceTime(100))
      .subscribe((isCtrl) => {
        if (!isCtrl) {
          for (const i in this.selectedItemsGroup) {
            const selectedItem = this.selectedItemsGroup[i];
            if (i != item.getId()) {
              this.removeFromSelectedGroup(selectedItem);
            }
          }
          this.addToSelectedGroup(item);
        } else {
          if (this.selectedItemsGroup.hasOwnProperty(item.getId())) {
            this.removeFromSelectedGroup(item);
          } else {
            this.addToSelectedGroup(item);
          }
        }
      });

  //  old listeners
    // item.emitter.subscribe((e)=>{
    //   this.onRemoved(e, item);
    // });

    // this.groupService.groupItemMoved$.subscribe((item)=>{
    //   this.updateAvailableItemConfig(item.config);
    // })

    item.emitter.subscribe((event)=>{
      if (event.getEventName() == 'objectChanged'){ // todo: move this to plugin
        this.serverConnection.updateObject(event.getPreparedItemConfig()).subscribe((response)=>{console.log('objectUpdated', response);})
      }

      if(event.getEventName() == 'updatedFromServer'){
        let objectConfig = event.getUpdatedConfig();

        // todo: rewrite this
        // item.title = objectConfig.title;
        // if (item.hasOwnProperty('inputs') && item.inputs) {
        //   Object.assign(itemObj[item.id].inputs, objectConfig.inputs);
        // }
        item.onRotationChange(objectConfig.objects[0].rotation);
      }

      if (event.getEventName() == 'removeObject'){
        this.removeItem(item);
      }
    });
  }

  // getSelectedItems(){
  //   return this.selectedItemsGroup;
  // }

  removeSelectedItems(group?:Item[]){
    if (group){
      group.forEach((item)=>{
        item.removeObject(null,{isSelectedRemove: true});
        delete this.selectedItemsGroup[item.getId()];
      });
    }
    else{
      for (let i in this.selectedItemsGroup){
        if (this.selectedItemsGroup.hasOwnProperty(i)){
          let item:Item = this.selectedItemsGroup[i];
          item.removeObject(null,{isSelectedRemove: true});
          delete this.selectedItemsGroup[i];
        }
      }
    }
    this._selectedItemList$.next(this.selectedItemsGroup);
  }

  clearSelectedItems(){
    // this.selectedItemsGroup = {};
    this.clearSelectedGroup();
    this._selectedItemList$.next(this.selectedItemsGroup);
  }

  public forEach(cb: CallableFunction) {
    let list = this._itemsList.getValue();
    for (let i in list) {
      if (list.hasOwnProperty(i)) {
        cb(list[i]);
      }
    }
  }

  private bindItemToGroup(item, itemList, cb) {
    let itemGroup = item.config.getGroupId();
    //if item hasn't group
    if (typeof itemGroup == "string"){
      let tool = item.config.getTool();
      if (tool){
        return this.processNewGroupByTool(tool, itemGroup, item, _itemGroup => {
          this.processItemGroup(item, _itemGroup, itemList, cb);
        });
      }
      else{
        //if item hasn't tool
        let emptyGroup = this.groupService.getGroupById(null);
        if (!emptyGroup){
          return this.groupService.initEmptyGroup((group)=>{
            this.processItemGroup(item, group, itemList, cb);
          })
        }
        return this.processItemGroup(item, emptyGroup, itemList, cb);
      }
    }
    //if item has group id
    else{
      let _itemGroup = this.groupService.getGroupById(itemGroup);
      if(_itemGroup){
        this.processItemGroup(item, _itemGroup, itemList, cb);
        return;
      }
      item.config.setGroupId(null);
      this.bindItemToGroup(item, itemList, cb);
    }
  }
}
